export default [
  'account',
  'mail',
  'settings'
];